// extracted by mini-css-extract-plugin
module.exports = {"container":"CalendarFilterSection_container__2bstB","title":"CalendarFilterSection_title__19_sI","filters":"CalendarFilterSection_filters__1ZlSk"};